function trimOrEmpty(value) {
  return (value || '').trim();
}

/** Produkcioni domen — koristi se kad REACT_APP_SITE_URL nije postavljen. */
export const DEFAULT_SITE_ORIGIN = 'https://wall-lux.rs';

/** Bazni URL sajta (bez završne /), npr. https://wall-lux.rs — za apsolutne OG slike. */
export function siteOrigin() {
  return trimOrEmpty(process.env.REACT_APP_SITE_URL).replace(/\/$/, '');
}

/**
 * Apsolutna URL za fajl iz public/, npr. /og-walllux-v2.png
 * Uvek apsolutna: og:image sa relativnom putanjom Fejsbuk/Viber/WhatsApp ignorišu.
 */
export function absolutePublicAsset(path) {
  const base = siteOrigin() || DEFAULT_SITE_ORIGIN;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/** Build-time iz .env (REACT_APP_*). */
export const externalUrls = {
  instagram: trimOrEmpty(process.env.REACT_APP_INSTAGRAM_URL),
  facebook: trimOrEmpty(process.env.REACT_APP_FACEBOOK_URL),
  whatsapp: trimOrEmpty(process.env.REACT_APP_WHATSAPP_URL),
  viber: trimOrEmpty(process.env.REACT_APP_VIBER_URL),
  googleMaps: trimOrEmpty(process.env.REACT_APP_GOOGLE_MAPS_URL),
};

/**
 * @param {string} url
 * @returns {object} props za <a> — bez URL-a: # i blokirani klik
 */
export function safeExternalAnchor(url) {
  const has = Boolean(url);
  return {
    href: has ? url : '#',
    onClick: has ? undefined : (e) => e.preventDefault(),
    ...(has ? { target: '_blank', rel: 'noopener noreferrer' } : { 'aria-disabled': true }),
  };
}
